<template>
  <div class="container">
    <SummaryReportHeader :loading="exporting" @export="exportReport" />
    <SummaryReportSummary />
    <SummaryReportCommunityProgress />
    <SummaryReportXTSAssessment />
    <SummaryReportVodVoice />
    <SummaryReportBaseCoBuild />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { message } from 'ant-design-vue';
import SummaryReportHeader from './SummaryReportHeader.vue';
import SummaryReportSummary from './SummaryReportSummary.vue';
import SummaryReportCommunityProgress from './SummaryReportCommunityProgress.vue';
import SummaryReportXTSAssessment from './SummaryReportXTSAssessment.vue';
import SummaryReportVodVoice from './SummaryReportVodVoice.vue';
import SummaryReportBaseCoBuild from './SummaryReportBaseCoBuild.vue';

const exporting = ref(false);

const exportReport = async () => {
  exporting.value = true;
  try {
    const element = document.querySelector('.container');
    if (!element) return;

    const ancestors = [];
    let parent = element.parentElement;
    while (parent && parent !== document.body) {
      const cs = window.getComputedStyle(parent);
      if (cs.overflow === 'hidden' || cs.overflow === 'auto') {
        ancestors.push({ el: parent, overflow: cs.overflow, height: parent.style.height });
        parent.style.overflow = 'visible';
        parent.style.height = 'auto';
      }
      parent = parent.parentElement;
    }

    const spacer = document.createElement('div');
    spacer.style.height = '80px';
    element.appendChild(spacer);

    const originalOverflow = element.style.overflow;
    const originalHeight = element.style.height;
    element.style.overflow = 'visible';
    element.style.height = 'auto';

    await new Promise((resolve) => setTimeout(resolve, 300));

    const originalScrollY = window.scrollY;
    const originalScrollX = window.scrollX;
    window.scrollTo(0, 0);

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
      scrollX: 0,
      scrollY: 0
    });

    window.scrollTo(originalScrollX, originalScrollY);

    element.style.overflow = originalOverflow;
    element.style.height = originalHeight;
    element.removeChild(spacer);

    ancestors.forEach(({ el, overflow, height }) => {
      el.style.overflow = overflow;
      el.style.height = height;
    });

    const imgData = canvas.toDataURL('image/jpeg', 0.92);
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;

    const pxToPt = 0.75;
    const pageWidth = imgWidth * pxToPt;
    const pageHeight = imgHeight * pxToPt;

    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'pt',
      format: [pageWidth, pageHeight],
      compress: true
    });

    pdf.addImage(imgData, 'JPEG', 0, 0, pageWidth, pageHeight);
    pdf.save('开发者生态综合月报.pdf');
    message.success('报告导出成功');
  } catch (error) {
    console.error('导出失败:', error);
    message.error('导出失败，请重试');
  } finally {
    exporting.value = false;
  }
};
</script>

<style scoped>
.container {
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
}
</style>
